/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-console */
import { createApi } from '@reduxjs/toolkit/query/react';
import { getRecognise, getRecogniseCount } from '../../actions/task_actions';
import { CreateRecognition, UpdateRecognition, closeCongratulationPopUp, deleteRecognise } from '../../actions/recognition_actions';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRecogniseData } from '../../../redux/RecogniseRedux';

export const recogniseApi = createApi({
	reducerPath : 'recogniseQuery',
	baseQuery   : () => {},
	tagTypes    : [ 'Recognise' ],
	endpoints   : (builder) => ({
		createRecognization : builder.mutation({
			async queryFn(request)
			{
				try
				{
					const { body, createQuery } = request;
					const res = await CreateRecognition(body, createQuery);

					if (res.status)
					{
						return res;
					}
				}
				catch (err)
				{
					console.log(err);
				}
			},
			invalidatesTags : [ 'Recognise' ]
		}),
		getRecogniseList : builder.query({
			async queryFn(query)
			{
				try
				{
					const response = await getRecognise(query);

					return response;
				}
				catch (error)
				{
					console.log('errr', error);
				}
			},
			providesTags : [ 'Recognise' ]
		}),
		getRecogniseListCount : builder.query({
			queryFn : async (query) =>
			{
				try
				{
					const response = await getRecogniseCount(query);

					return response;
				}
				catch (error)
				{
					console.log('errrr,', error);
				}
			},
			providesTags : [ 'Recognise' ]
		}),
		deleteRecogniseItem : builder.mutation({
			async queryFn(query)
			{
				try
				{
					const deleteItem = await deleteRecognise(query);

					if (deleteItem.status)
					{
						return deleteItem;
					}
				}
				catch (error)
				{
					console.log('errorrrr', error, query);
				}
			},
			invalidatesTags : [ 'Recognise' ]
		}),
		updateRecognizationItem : builder.mutation({
			async queryFn(request)
			{
				try
				{
					const { body, query } = request;
					const res = await UpdateRecognition(query, body);

					if (res.status)
					{
						return res;
					}
				}
				catch (err)
				{
					console.log(err);
				}
			},
			invalidatesTags : [ 'Recognise' ]
			// async onQueryStarted({ body }, { dispatch, queryFulfilled })
			// {
			// 	console.log('async', body);
			// 	const patchResult = dispatch(
			// 		recogniseApi.util.updateQueryData('getRecogniseList', undefined, (recognise) =>
			// 		{
			// 			console.log('console kivbskvbskvsn', recognise);
			// 		})
			// 	);

			// 	try
			// 	{
			// 		await queryFulfilled;
			// 	}
			// 	catch (error)
			// 	{
			// 		patchResult.undo();
			// 	}
			// }
		}),
		closeCongratsPopup : builder.mutation({
			async queryFn(request)
			{
				const { query, body } = request;

				try
				{
					await closeCongratulationPopUp(query, body);
				}
				catch (error)
				{
					console.log('errorrrr', error);
				}
			}
		})
	})
});

export const { useGetRecogniseListQuery, useGetRecogniseListCountQuery,
	useCreateRecognizationMutation, useDeleteRecogniseItemMutation, useUpdateRecognizationItemMutation, useCloseCongratsPopupMutation } = recogniseApi;